import { render } from "./CategoryTile.vue?vue&type=template&id=5673254e&scoped=true"
import script from "./CategoryTile.vue?vue&type=script&lang=js"
export * from "./CategoryTile.vue?vue&type=script&lang=js"

import "./CategoryTile.vue?vue&type=style&index=0&id=5673254e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5673254e"]])

export default __exports__